import { useReveal } from "@/hooks/useReveal";

const CARDS = [
  {
    number: "1",
    title: "Through your existing distributor",
    body: "The most common route. You tell us who supplies your beverage consumables, we deal with them directly on documentation, pricing and shipping, and you keep the single invoice and the delivery schedule you already have.",
  },
  {
    number: "2",
    title: "Through a local importer we introduce",
    body: "If you do not have a distributor carrying certified organic lines, we can work with a specialist importer to hold stock locally, so your sites order the way they always have.",
  },
  {
    number: "3",
    title: "Direct, for larger groups",
    body: "For groups consolidating across several sites, direct import from half a 40 ft container upwards. FOB Cartagena or Buenaventura, or CIF Cape Town or Durban on request.",
  },
];

export default function HowWeSupply() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="supply" className="bg-cream py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal max-w-2xl">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            How we actually supply you
          </h2>
          <p className="mt-4 text-ink/70 text-lg leading-relaxed">
            We are realistic about this. A café group in Cape Town does not
            want to open an import file with a manufacturer in Colombia, and it
            should not have to. There are three ways this works, and we are
            comfortable with all three.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {CARDS.map((card) => (
            <div
              key={card.number}
              className="bg-white rounded-lg p-7 border border-cream-dark/60"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-brand text-white font-serif text-lg font-semibold">
                {card.number}
              </span>
              <h3 className="mt-5 text-ink font-serif text-lg md:text-xl font-semibold">
                {card.title}
              </h3>
              <p className="mt-3 text-ink/70 text-[17px] leading-relaxed">
                {card.body}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 border border-brown/30 rounded-lg bg-white px-6 py-5">
          <p className="text-ink/80 text-[17px] leading-relaxed">
            If you already have a distributor, name them in the form and we
            will approach them, not around them.
          </p>
        </div>
      </div>
    </section>
  );
}